import { Injectable } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment.development';
import { HttpClient } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class TimesheetService {

  private baseUrl = environment.baseUrl;
  constructor(private http: HttpClient, private msalService: MsalService) { }

  async getAccessToken(): Promise<string | null> {
    const account = this.msalService.instance.getActiveAccount();
    if (!account) {
      console.warn('No active MSAL account found');
      return null;
    }

    try {
      const response = await this.msalService.instance.acquireTokenSilent({
        account,
        scopes: ['https://graph.microsoft.com/Calendars.Read']
      });
      return response.accessToken;
    } catch (error) {
      console.error('Failed to acquire token silently', error);
      return null;
    }
  }

  async getCalendarEvents(): Promise<any> {
    const token = await this.getAccessToken();
    if (!token) {
      throw new Error('Access token is null');
    }

    // Call Microsoft Graph API for calendar events
    const result = await firstValueFrom(
      this.http.get('https://graph.microsoft.com/v1.0/me/calendar/events', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    );

    return result;
  }

  getCalendarEventsWithToken(token: string, startDate: Date, endDate: Date): Promise<any> {
    const start = this.formatDateToGraphApi(startDate);
    const end = this.formatDateToGraphApi(endDate);

    // const url = `https://graph.microsoft.com/v1.0/me/calendarView?startDateTime=${startDate}&endDateTime=${endDate}&$filter=isCancelled eq false&$select=subject,start,end`;
    const url = `https://graph.microsoft.com/v1.0/me/calendarView?startDateTime=${start}&endDateTime=${end}&$filter=isCancelled eq false&$select=subject,start,end`;
    //  const url = `https://graph.microsoft.com/v1.0/me/calendarView?startDateTime=2025-06-26T00:00:00Z&endDateTime=2025-06-26T23:59:59Z&$filter=isCancelled eq false&$select=subject,start,end`
    return firstValueFrom(
      this.http.get(url, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).pipe(
        catchError(err => {
          console.error('Graph API error in service:', err);
          throw err;
        })
      )
    );
  }

  formatDateToGraphApi(date: Date): string {
    return date.toISOString().split('.')[0] + 'Z';
  }

  GetTimeSheetList(userId: any, startDate: string, endDate: string) {
    const url = `${this.baseUrl}/TimeSheet/TimeSheetList?userId=${userId}&startDate=${startDate}&endDate=${endDate}`;
    return this.http.get<any>(url);
  }

  GetAllTimeSheetList() {
    const url = `${this.baseUrl}/TimeSheet/AllTimeSheetList`;
    return this.http.get<any>(url);
  }

  revertTimesheet(userId: any, workDate: string) {
    const url = `${this.baseUrl}/TimeSheet/RevertTimesheet?userId=${userId}&workDate=${workDate}`;
    return this.http.delete<any>(url);
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getTimesheetData(userId: number, startDate?: Date, endDate?: Date): Observable<any[]> {
    let url = `${this.baseUrl}/TimeSheet/TimeSheetList?userId=${userId}`;

    if (startDate && endDate) {
      const formattedStart = this.formatDate(startDate);
      const formattedEnd = this.formatDate(endDate);
      url += `&startDate=${formattedStart}&endDate=${formattedEnd}`;

      console.log(url);
    }

    return this.http.get<any[]>(url);
  }

  getProjectNames(userId: string) {
    const url = `${this.baseUrl}/Drop/UserProjectDropDown?userid=${userId}`;
    return this.http.get(url);
  }

  getHolidayDates() {
    const url = `${this.baseUrl}/TimeSheet/GetHolidays`;
    return this.http.get(url);
  }
  
  getThirdPartyProjectNames() {
    //return this.http.get('https://timesheet.i2econsulting.com/timesheet/get_project_list');
    const url = `${this.baseUrl}/TimeSheet/GetProjectListProxy`;
    return this.http.get<any[]>(url).pipe(
    map((projects: any[]) => projects.filter(project => project.IsActive === true))
  );

  }

  getThirdPartyActivityNames() {
    //return this.http.get('https://timesheet.i2econsulting.com/assets/project.json');

    const url = `${this.baseUrl}/TimeSheet/projectjsonProxy`;
    return this.http.get(url);
  }

  getTaskNames(projectId: number) {
    const url = `${this.baseUrl}/Task/GetTaskListByProjectId?projectId=${projectId}`;
    return this.http.get(url);
  }

  saveTimeSheetData(timeSheetData: any[]) {
    const url = `${this.baseUrl}/TimeSheet/AddTimeSheetList`;
    return this.http.post(url, timeSheetData);
  }

  copyTimeSheetData(timeSheetData: any[]) {
    const url = `${this.baseUrl}/TimeSheet/CopyTimeSheet`;
    return this.http.post(url, timeSheetData);
  }

  submitPunch(punchData: any) {
    const url = `${this.baseUrl}/TimeSheet/AddOrUpdatePunchDetail`
    return this.http.post(url, punchData);
  }

  getPunchDetail(user_Id: number, punch_Date: Date) {
    const formattedDate = punch_Date.toISOString().split('T')[0];
    const url = `${this.baseUrl}/TimeSheet/PunchDetail?userId=${user_Id}&punchDate=${formattedDate}`;
    return this.http.get(url);
  }

  async getUserProfile(accessToken: string) {

  const response = await fetch(
    "https://graph.microsoft.com/v1.0/me?$select=employeeId,givenName,surname,userPrincipalName,id,jobTitle,displayName,department",
    {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }
  );

  const text = await response.text();

  return {
    status: response.status,
    ok: response.ok,
    body: text
  };
}


  //  getTimesheetList(): Observable<any[]> {
  //   return this.http.get<any[]>(`${this.baseUrl}/Timesheet/GetTimesheetList`);
  // }

//   getTimesheets(userId: string, month: number, year: number): Observable<any> {
//   return this.http.get<any>(`/api/Timesheet/GetTimesheets?userId=${userId}&month=${month}&year=${year}`);
// }
  getTimesheetList(month: number, year: number): Observable<any[]> {
  return this.http.get<any[]>(`${this.baseUrl}/Timesheet/GetTimesheetList?month=${month}&year=${year}`);
}

saveThirdPartyTimesheet(data: {
  Json_data: any[];
  empid: string;
}) {
  // const url = 'https://timesheet.i2econsulting.com/timesheet/savetimesheet';
  // return this.http.post(url, data);
 
  const url =  `${this.baseUrl}/TimeSheet/SaveTimesheetProxy`;
return this.http.post(url, data);
}


updateUserByDate(data: any): Observable<any> {
  return this.http.post(`${this.baseUrl}/Timesheet/UpdateByDate`, data);
}

}